export interface MessagePart {
  type: string;
  text?: string;
  agent_name?: string;
  tool_name?: string;
  value?: string;
  /** text 带 metadata.tool_call_id 时归入 think 内 */
  metadata?: {
    tool_call_id?: string;
  };
  data?: {
    type: string;
    value: string;
    title?: string;
    data_type?: string;
    [key: string]: any;
  };
}

export interface HistoryMessage {
  message_id: string;
  answer: Array<{
    type: string;
    data?: {
      type: string;
      value: string;
    };
    text?: string;
  }>;
  query: string;
}

/**
 * 对话类型枚举
 * AI_CHAT: AI智能问答
 * DS_AGENT_CHAT: Data Science专业报告生成
 * MAGIC_POSTER: 数据魔法海报（AI Magic Poster）
 */
export enum ChatTypes {
  AI_CHAT = 'aiAgent',
  DS_AGENT_CHAT = 'dsReport',
  AI_TABLE_CHAT = 'aiExcel',
  // MAGIC_POSTER = 'magicPoster',
}

export interface IStreamChunk {
  data?: string;
  [key: string]: unknown;
}